module.exports = __webpack_public_path__ + "img/people-rot.f7d19148.svg";